import React from 'react';
import { Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import SummaryStatCard from '../common/SummaryStatCard';
import { formatCurrency } from '../../utils/currencyUtils';

const StockSummaryCards = ({
  lowStockCount = 0,
  negativeStockCount = 0,
  stockValueEstimate,
  canSeeCosts = false,
  currency,
}) => {
  const { t } = useTranslation();

  return (
    <Stack id="stock-summary-cards" direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ mb: 3 }}>
      <SummaryStatCard label={t('stock.summary.low')} formattedValue={String(lowStockCount)} />
      <SummaryStatCard label={t('stock.summary.negative')} formattedValue={String(negativeStockCount)} />
      {canSeeCosts && stockValueEstimate != null ? (
        <SummaryStatCard
          label={t('stock.summary.value')}
          formattedValue={formatCurrency(stockValueEstimate, currency)}
        />
      ) : null}
    </Stack>
  );
};

export default StockSummaryCards;
